<template>
  <div id="contents" class="main contents">
    <promotion-banner></promotion-banner>
    <products-list
      v-if="collectionList.length === 0 && newList.length"
      :productList="makeProductList('newList', newList)"
      :isNewList="true"
      :isMore="control.newList.isMore"
      :listTitle="'NEW'"
      :isRewardUse="true"
      @getMoreList="() => getMoreList({ type: 'newList' })"
    ></products-list>
    <template v-if="collectionList.length">
      <products-list
        v-for="(el, idx) in collectionList"
        :key="idx"
        :productList="
          makeProductList('collectionList', el.collectionProductList, idx)
        "
        :listTitle="el.collectionName"
        :collectionIndex="idx"
        :isMore="control.collectionList[idx].isMore"
        :isRewardUse="true"
        @getMoreList="() => getMoreList({ type: 'collectionList', index: idx })"
      ></products-list>
    </template>
  </div>
</template>

<script>
import MainAPI from '@/api/main'
import PromotionBanner from '@/views/base/PromotionBanner'
import ProductsList from '@/views/shop/ProductsList'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Main',
  components: {
    PromotionBanner,
    ProductsList
  },
  data() {
    return {
      collectionInfo: {}
    }
  },
  computed: {
    ...mapGetters('main', ['control', 'newList', 'collectionList'])
  },
  methods: {
    ...mapActions('main', ['getHomeData', 'getMoreList']),
    makeProductList(type, list, index) {
      let result = []
      let control = this.control[type]
      if (list && control) {
        if (typeof index != 'undefined') {
          control = control[index]
        }
        result = list.slice(0, control.size)
      }
      return result
    }
  },
  mounted() {
    this.getHomeData()
  }
}
</script>

<style lang="scss"></style>
